export const CUSTOMER_ROLE = 0;
export const SUPPLIER_ROLE = 1;
export const CUSTOMER_ADMIN = 'CUSTOMER_ADMIN';
export const ORDER_LIST = 'ORDER_LIST'; 
export const REPORTING = 'REPORTING';

export const menuItems = [
    
    ///////////////////
    // Customer Menu 

    {
        id: 1,
        label: 'Accueil',
        icon: 'fas fa-home',
        withIcon: true,
        subItems:[],
        link: '/', 
        role:CUSTOMER_ROLE,
        
    },

    {
        id: 2,
        label: 'Analytics',
        icon: 'fas fa-chart-line ',
        subItems:[],
        link:"/analytics",
        role:CUSTOMER_ROLE,
    },
 

    ///////////////////
    // Supplier Menu 
    
    {
        id: 100,
        label: 'Accueil',
        subItems:[],
        link: '/',
        role:SUPPLIER_ROLE,
    },


    {
        id: 101,
        label: 'Zones et Partenaires',
        link: '/zone',
        role:SUPPLIER_ROLE,
     
    },

    

    {
        id: 104,
        label: 'Campagnes',
        icon: 'fas fa-user-cog',
        link:'/campaign',
        role:SUPPLIER_ROLE,
    
    },

    {
        id: 106,
        label: 'Analytics',
        icon: 'fas fa-chart-line ',
        subItems:[],
        link:"/reporting",
        role:SUPPLIER_ROLE,
    },

    {
        id: 103,
        label: 'Utilisateurs',
        link:'/utilisateurs',
        role:SUPPLIER_ROLE,
    
    },

    {
        id: 105,
        label: 'Système',
        icon: 'fas fa-bullhorn ',
        subItems:[],
        link:"/bannieres",
        role:SUPPLIER_ROLE,
    },

    {
        id: 107,
        label: 'Devis',
        subItems:[],
        link:"/demande/devis",
        role:SUPPLIER_ROLE,
    },



];

